import SocietyFilter from './SocietyFilter';
import { Society, SocietyFilters } from '../../../../app/models/Society';
import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import SocietySwitchChange from '../SocietySwitchChange';

interface Props {
    societies: Society[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: SocietyFilters;
    setFilter: (filter: SocietyFilters) => void;
    paginationRowsPerPageOptions?: number[];
    callbackSuccess: () => void;
    onSearch: () => void;
}

const SocietyDataTable = ({
    societies,
    totalRows,
    loading = false,
    edit,
    destroy,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess,
    onSearch
}: Props) => {
    const columns = [
        {
            name: 'RUT',
            selector: (row: Society) => row.rut || '',
            sortable: true,
            sortField: 'rut',
            cell: (row: Society) => (
                <span className="">{row.rut || ''}</span>
            )
        },
        {
            name: 'Razón Social',
            selector: (row: Society) => row.business_name || '',
            sortable: true,
            sortField: 'businessName',
            cell: (row: Society) => (
                <span className="">{row.business_name || ''}</span>
            )
        },
        {
            name: 'Dirección',
            selector: (row: Society) => row.address || '',
            sortable: true,
            sortField: 'address',
            cell: (row: Society) => (
                <span className="">{row.address || ''}</span>
            )
        },
        {
            name: 'País',
            selector: (row: Society) => row.country || '',
            sortable: true,
            sortField: 'country',
            cell: (row: Society) => (
                <span className="">{row.country || ''}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: Society) => row?.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: Society) => (
                <SocietySwitchChange
                    checkValue={row.is_active ?? true}
                    societyId={row.id ?? 0}
                    callbackSuccess={callbackSuccess}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: Society) => row.id,
            sortable: false,
            cell: (row: Society) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? -1)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            errorMessage={'No se puede eliminar este registro.'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <SocietyFilter filter={filter} setFilter={setFilter} onSearch={onSearch}/>
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={societies}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default SocietyDataTable;
